import React, { useEffect, useRef, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import SelectBox from "../../../components/SelectBox";
import { useLocation } from "react-router-dom";
import { get, post } from "../../../Services/ApiHandler";
import {
  green_icon,
  red_icon,
  user,
  edit_icon,
  delete_icon,
  user_icon,
  user_img,
} from "../../../assets/imgs";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import moment from "moment";
import { URL } from "../../../Services/Constant";
import CompanyGroupView from "../../../components/CompanyGroupView";
import CompanySitesAdd from "../../../components/CompanySitesAdd";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toast } from "react-toastify";
import { storedPermissions } from "../../../components/storedPermissions";

const CompanyGroupUsers = () => {
  const [siteList, setSiteList] = useState([]);
  const [siteData, setSiteData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [groupUsers, setGroupUsers] = useState([]);
  const [groupPopup, setGroupPopup] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [flagEmail2, setFlagEmail2] = useState(0);
  const [fullData2, setFullDate2] = useState({});
  const groupNameRef = useRef(null);
  const [emailCheckDataGroup, setEmailCheckDataGroup] = useState({});
  const [popup2, setPopup2] = useState(false);
  const [admindetails, setAdminDetails] = useState({});
  const [emailCheckFlag, setEmailCheckFlag] = useState(0);
  const [mode, setMode] = useState("edit"); // "view" or "edit" - you can control this via props or state
  const { pathname } = useLocation();
  let permission = JSON.parse(localStorage.getItem("user_permission") ?? "[]");

  let companyViewAllowed =
    permission?.includes("CAN-View-KNF_COMPANY_GROUP_USER") &&
    pathname == "/company-group-users-list";
  // console.log("companyViewAllowed", companyViewAllowed);

  let companyAddAllowed =
    permission?.includes("CAN-Add-KNF_COMPANY_GROUP_USER") &&
    pathname == "/company-group-users-list";

  // State for site admin details
  const [siteAdminDetails, setSiteAdminDetails] = useState({
    name: "",
    email: "",
    mobile: "",
    image: "",
    is_email_verified: false,
    created_at: "",
  });

  const groupFormObj = {
    groupName: "",
    groupEmail: "",
    groupMobile: "",
    groupCategory: "",
    groupImage: "",
    alert: 0,
    beep: 1,
  };

  const [groupForm, setGroupForm] = useState(groupFormObj);
  const [groupErrors, setGroupErrors] = useState({});
  const fileInputRef = useRef(null);

  const groupUserImageRef = useRef(null);

  const getSiteList = () => {
    get(URL.ACTIVE_SITE + "?knf_type=1")
      .then((res) => {
        if (res?.sites?.length > 0) {
          setSiteList(res?.sites);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // Function to get site admin details
  const getSiteAdminDetails = (site_id) => {
    get(URL.SITE_VIEW + site_id)
      .then((res) => {
        let data = res?.data?.[0];
        if (data) {
          setSiteAdminDetails({
            name: data?.user_name || "",
            email: data?.user_email || "",
            mobile: data?.user_phone || "",
            image: data?.profile_image || "",
            is_email_verified: data?.is_email_verified || false,
            created_at: data?.created_at
              ? moment(data?.created_at).format("DD-MM-YYYY")
              : "",
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getGroupRole = () => {
    get(URL.GROUP_ROLE_LIST)
      .then((res) => {
        setGroupList(res?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getSiteUser = (site_id) => {
    let formdata = new FormData();
    formdata.append("knf_type", 1);
    formdata.append("site_id", site_id);
    post(URL.GROUP_USER_LIST, formdata)
      .then((res) => {
        let temp = [];
        res?.lists?.map((item, ind) => {
          let obj = {
            ...item,
          };
          if (item?.group_category == 3) {
            obj.group_category = 1;
          }
          if (item?.group_category == 4) {
            obj.group_category = 2;
          }
          if (item?.group_category == 5) {
            obj.group_category = 3;
          }
          temp.push(obj);
        });
        if (res?.lists?.length > 0) {
          setGroupUsers(res?.lists);
        } else {
          setGroupUsers([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // Active/Deactive functionality
  const groupUserStatus = (id) => {
    get(URL.GROUP_USER_STATUS + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          if (selectedOption?.value) {
            getSiteUser(selectedOption?.value);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // Delete functionality
  const deleteGroupUser = (id) => {
    post(URL.GROUP_USER_DELETE + id, {})
      .then((res) => {
        if (res?.status == "success") {
          handleResetGroup();
          toast.success(res?.message);
          setGroupPopup(false);
          if (selectedOption?.value) {
            getSiteUser(selectedOption?.value);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGroupChange = (e) => {
    const { name, value } = e.target;
    if (name == "groupCategory" && value == 3) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 1, beep: 1 }));
    } else if (name == "groupCategory" && value == 4) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 0, beep: 0 }));
    } else if (name == "groupCategory" && value == 5) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 0, beep: 0 }));
    } else {
      setGroupForm((prev) => ({ ...prev, [name]: value }));
    }
    setGroupErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleGroupImage = (event, name) => {
    let image = event.target.files[0];
    if (image) {
      setGroupForm((prev) => ({
        ...prev,
        [name]: image,
      }));
      setGroupErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleResetGroup = () => {
    setGroupForm({
      groupName: "",
      groupEmail: "",
      groupMobile: "",
      groupCategory: "",
      groupImage: "",
      alert: 0,
      beep: 0,
    });
    setFlagEmail2(0);
    setFullDate2({});
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validateGroup = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (groupForm?.groupName?.length == 0)
      newErrors.groupName = "Group user name is required";
    if (
      groupForm.groupEmail?.length == 0 ||
      !emailRegex.test(groupForm.groupEmail)
    )
      newErrors.groupEmail = "Valid email is required";

    if (
      groupForm.groupMobile?.length == 0 ||
      !singaporeMobileRegex.test(groupForm.groupMobile)
    ) {
      newErrors.groupMobile = "Enter valid 8-digit Singapore number";
    }

    if (groupForm.groupCategory?.length == 0)
      newErrors.groupCategory = "Category is required";

    if (groupForm.groupCategory == 3) {
      if (!groupForm.alert) {
        newErrors.alert = "Alert Notifications should be enabled";
      }
      if (groupForm.beep && !groupForm.alert) {
        newErrors.beep =
          "Beep Sound cannot be enabled without enabling Alert Notifications";
      }
    }
    setGroupErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Add/Edit functionality
  const handleGroupAdd = () => {
    if (validateGroup()) {
      let formdata = new FormData();
      formdata.append("name", groupForm.groupName);
      formdata.append("phone", groupForm.groupMobile);
      formdata.append("email", groupForm.groupEmail);
      formdata.append("knf_type", 1);
      formdata.append("notification_alert", groupForm.alert);
      formdata.append("beep_sound", groupForm.beep);
      formdata.append("group_category", groupForm.groupCategory);
      formdata.append("site_id", selectedOption?.value);

      if (groupForm.groupImage?.name) {
        formdata.append("profile_image", groupForm.groupImage);
      }

      if (groupForm?.id) {
        // Update existing user
        post(URL.GROUP_USER_UPDATE + groupForm?.id, formdata)
          .then((res) => {
            if (res?.status == "success") {
              handleResetGroup();
              toast.success(res?.message);
              if (selectedOption?.value) {
                getSiteUser(selectedOption?.value);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        // Add new user
        post(URL.GROUP_USER_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              handleResetGroup();
              toast.success(res?.message);
              if (selectedOption?.value) {
                getSiteUser(selectedOption?.value);
              }
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
    }
  };

  // Edit functionality - sets form with user data for editing
  const handleGroupEdit = (item) => {
    if (item) {
      setFullDate2(item);
      setGroupForm({
        id: item?.id,
        groupName: item?.name,
        groupEmail: item?.email,
        groupMobile: item?.phone,
        groupCategory: item?.group_category,
        alert: item?.notification_alert,
        beep: item?.beep_sound,
        groupImage: item?.profile_image,
        groupEmail_verify: true,
      });
      setFlagEmail2(0);

      setTimeout(() => {
        if (groupNameRef.current) {
          groupNameRef.current.focus();
        }
      }, 0);
    }
  };

  const autoFetchDataGroup = (data_new) => {
    let data = {
      ...data_new?.user,
      company: {
        ...data_new?.company,
        site: data_new?.site,
      },
    };
    setEmailCheckDataGroup(data);
    let ob = {
      groupName: "",
      groupEmail: "",
      groupMobile: "",
      groupCategory: "",
      groupImage: "",
      alert: 0,
      beep: 1,
      email_verified: data?.id ? 1 : 0,
    };

    if (data?.id) {
      ob.id = data?.id;
    }

    if (data?.email) {
      ob.groupEmail = data?.email;
      ob.groupEmail_verify = true;
    }

    if (data?.name) {
      ob.groupName = data?.name;
    }
    if (data?.phone) {
      ob.groupMobile = data?.phone;
    }
    if (data?.profile_url) {
      ob.groupImage = data?.profile_url;
    }
    if (data?.knf_type) {
      ob.groupCategory = data?.knf_type;
    }
    if (data?.beep_sound) {
      ob.beep = data?.beep_sound;
    }
    if (data?.notification_alert) {
      ob.alert = data?.notification_alert;
    }

    setGroupForm(ob);
  };

  const emailCheckGroup = () => {
    let formdata = new FormData();
    let count = 1;
    if (groupForm.groupEmail?.length > 0) {
      count = count;
    } else {
      count = count + 1;
    }
    if (count == 1) {
      formdata.append("email", groupForm.groupEmail);
      post("user/" + URL.EMAIL_CHECK, formdata)
        .then((res) => {
          setFlagEmail2(0);
          let data = res?.userData?.[0];
          if (
            res?.exists &&
            res?.message == "This email is already an admin."
          ) {
            toast.error(res?.message);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } else if (res?.exists && groupForm?.id) {
            toast.error(res?.message);
            setEmailCheckFlag(0);
            let data = res?.userData?.[0];
            let emCheck = {
              ...data?.user,
              company: data?.company,
            };
            setAdminDetails(emCheck);
            if (emCheck?.id) {
              setPopup2(true);
            } else {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } else {
            if (res?.userData?.length > 0) {
              if (data?.user?.knf_type >= 3 && data?.user?.knf_type <= 5) {
                autoFetchDataGroup(data);
              } else if (data?.user?.knf_type == null) {
                autoFetchDataGroup(data);
              } else {
                toast.error("Email ID already exists");
              }
            } else {
              let ob = {
                ...(groupForm.id ? groupForm : groupFormObj),
                groupEmail: groupForm.groupEmail,
              };
              if (groupForm.id) {
                ob.id = groupForm.id;
              }
              setGroupForm(ob);
              setEmailCheckDataGroup({});
              toast.info("You can edit the details");
              if (!groupForm.id) {
                toast("please enter all required fields");
              }
            }
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };

  useEffect(() => {
    getSiteList();
    getGroupRole();
  }, []);

  const isEmailVerified = flagEmail2 === 0 && groupForm?.groupEmail;

  console.log("groupForm", groupForm);

  return (
    <div className="dashRightView">
      <StatusComp name={"Group Users"} hide={true} />

      {/* Site Select */}
      <div className={`d-flex w-100 ac-js mb-4`}>
        {/* {console.log("storedPermissions", storedPermissions)} */}
        {/* {storedPermissions.includes("CAN-View-KNF_COMPANY_GROUP_USER") && ( */}
        {companyViewAllowed && (
          <div className="mx-4">
            <label className="form-label">Select Site</label>
            <SelectBox
              arrayData={siteList}
              data={siteData}
              setData={setSiteData}
              selectedOption={selectedOption}
              setSelectedOption={(val) => {
                setSelectedOption(val);
                getSiteUser(val?.value);
                getSiteAdminDetails(val?.value);
                handleResetGroup();
              }}
              isClearable={false}
              style={true}
            />
          </div>
        )}
        {/* )} */}
      </div>

      {/* Site Admin Details Section */}
      {selectedOption?.value && siteAdminDetails.name && (
        <>
          {pathname !== "/company-group-users-list" && (
            <div className="d-flex p-1">
              <div className="col-md-4 p-3">
                <div className="p-2 mb-2">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Site Admin
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={siteAdminDetails?.name}
                  />
                </div>

                <div className="p-2 mb-2">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Site Admin Email
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={siteAdminDetails?.email}
                  />
                  <div className="d-flex ac-js mt-2 gap-2">
                    <img
                      src={
                        siteAdminDetails?.is_email_verified
                          ? green_icon
                          : red_icon
                      }
                      className="redImg"
                      alt="verification status"
                    />
                    <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                      {siteAdminDetails?.is_email_verified
                        ? "Verified"
                        : "Not Verified"}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 p-3">
                <div className="p-2 mb-2">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Site Admin Primary Mobile
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={siteAdminDetails?.mobile}
                  />
                </div>
                <div className="p-2 mb-2">
                  <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
                    Admin Created On
                  </p>
                  <input
                    className="input-box w-100"
                    readOnly
                    value={siteAdminDetails?.created_at}
                  />
                </div>
              </div>
              {siteAdminDetails?.image && (
                <div className="col-md-4 p-3 d-flex ac-jc">
                  <img
                    src={siteAdminDetails?.image}
                    className="user"
                    alt="Site Admin"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </div>
              )}
            </div>
          )}
          <hr className="border-t-2 border-gray-400 mb-5" />
        </>
      )}

      {/* Group Users Add Section - Only show in edit mode */}
      {selectedOption?.value && mode !== "view" ? (
        <>
          {companyAddAllowed && (
            <div className="w-100">
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 black">
                Add/Edit Group Users
              </p>

              <div className="row mt-4 g-3 align-items-end">
                <div className="col-12 col-sm-6 col-md-4 col-lg-2 position-relative">
                  <p className="f3 mb-1 primary">
                    Email<span className="text-danger">*</span>
                  </p>
                  <input
                    name="groupEmail"
                    value={groupForm.groupEmail}
                    onChange={(val) => {
                      handleGroupChange(val);
                      setFlagEmail2(1);
                    }}
                    className="input-box w-100"
                    type="email"
                    placeholder="Email"
                  />
                  {groupErrors.groupEmail && (
                    <p className="err">{groupErrors.groupEmail}</p>
                  )}
                  {groupForm?.groupEmail?.length > 2 && (
                    <p
                      className="position-absolute text-primary pointer end-0 fw-bold"
                      style={{ cursor: "pointer", top: "70px", right: "10px" }}
                      onClick={() => {
                        if (groupForm?.id) {
                          if (fullData2?.email == groupForm.groupEmail) {
                            toast.error("Same Email Entered");
                          } else {
                            emailCheckGroup();
                          }
                        } else {
                          emailCheckGroup();
                        }
                      }}
                    >
                      Check
                    </p>
                  )}
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p className="f3 mb-1 primary">
                    User Name<span className="text-danger">*</span>
                  </p>
                  <input
                    className={`input-box w-100 ${
                      !isEmailVerified ? "opacity-50" : ""
                    }`}
                    ref={groupNameRef}
                    name="groupName"
                    value={groupForm.groupName}
                    onChange={handleGroupChange}
                    type="text"
                    placeholder="Group user name"
                    disabled={!isEmailVerified}
                  />
                  {groupErrors.groupName && (
                    <p className="err">{groupErrors.groupName}</p>
                  )}
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p className="f3 mb-1 primary">
                    Singapore Mobile<span className="text-danger">*</span>
                  </p>
                  <input
                    name="groupMobile"
                    value={groupForm.groupMobile}
                    maxLength={8}
                    onChange={handleGroupChange}
                    className={`input-box w-100 ${
                      !isEmailVerified ? "opacity-50" : ""
                    }`}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 8))
                    }
                    type="number"
                    placeholder="+65 Mobile"
                    disabled={!isEmailVerified}
                  />
                  {groupErrors.groupMobile && (
                    <p className="err">{groupErrors.groupMobile}</p>
                  )}
                </div>

                <div className="col-12 col-sm-6 col-md-4 col-lg-2 ms-5">
                  <p
                    className="f3 primary d-flex"
                    style={{ marginBottom: "-4%" }}
                  >
                    User Image
                  </p>
                  <span className="text-danger fs-12">
                    JPG, JPEG, PNG only | Max size: 5MB
                  </span>

                  <input
                    name="groupImage"
                    onChange={(e) => handleGroupImage(e, "groupImage")}
                    className={`input-box w-100 ${
                      !isEmailVerified ? "opacity-50" : ""
                    }`}
                    type="file"
                    accept="image/*"
                    placeholder="User Image"
                    ref={fileInputRef}
                    disabled={!isEmailVerified}
                    style={{
                      display: "none",
                    }}
                  />
                  <div className="col-md-3 d-flex ac-jb gap-3">
                    <img
                      src={
                        groupForm.groupImage
                          ? typeof groupForm.groupImage === "string"
                            ? groupForm.groupImage
                            : window.URL.createObjectURL(groupForm.groupImage)
                          : user_img
                      }
                      alt="group Logo"
                      className={`user pointer ${!isEmailVerified ? "opacity-50" : ""}`}
                      style={{
                        borderRadius: "50px",
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                      onClick={() => fileInputRef.current?.click()}
                    />

                    <img
                      src={edit_icon}
                      alt="Edit"
                      className={`edit-btn pointer ${!isEmailVerified ? "opacity-50" : ""}`}
                      style={{ cursor: "pointer" }}
                      onClick={() => fileInputRef.current?.click()}
                      disabled={!isEmailVerified ? true : false}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                  <p className="f3 mb-1 primary">
                    Select Group<span className="text-danger">*</span>
                  </p>
                  <select
                    name="groupCategory"
                    onChange={handleGroupChange}
                    value={groupForm.groupCategory}
                    className={`input-box w-100 ${
                      !isEmailVerified ? "opacity-50" : ""
                    }`}
                    // disabled={groupForm?.groupEmail_verify ? true : false}
                    disabled={!isEmailVerified}
                  >
                    <option value={""}>Select</option>
                    {groupList?.map((item, ind) => {
                      return (
                        <option value={item?.id} key={ind}>
                          {item?.name}
                        </option>
                      );
                    })}
                  </select>
                  {groupErrors.groupCategory && (
                    <p className="err">{groupErrors.groupCategory}</p>
                  )}
                </div>

                {/* {storedPermissions?.includes(
                "CAN-Add-KNF_COMPANY_GROUP_USER",
              ) && ( */}
                <div className="col-12 col-sm-6 col-md-4 col-lg-1 d-flex align-items-end">
                  {flagEmail2 == 0 && (
                    <button
                      onClick={handleGroupAdd}
                      className="medium-btn ms-4 d-flex align-items-center justify-content-center gap-2"
                    >
                      {/* <CheckCircleIcon fontSize="small" /> */}
                      Add
                    </button>
                  )}
                </div>
                {/* )} */}
              </div>

              <div className="d-flex justify-content-center gap-5 me-5 mt-3">
                {/* Alert Notifications */}
                <div className="d-flex flex-column align-items-center me-5">
                  <p className="f3 mb-1 primary">Alert Notifications</p>
                  {!groupForm.alert ? (
                    <ToggleOffIcon
                      sx={{ fontSize: 60, color: "gray", cursor: "pointer" }}
                      onClick={() => {
                        setGroupForm((prev) => ({
                          ...prev,
                          alert: 1,
                        }));
                        setGroupErrors((prev) => ({
                          ...prev,
                          alert: "",
                          beep: "",
                        }));
                      }}
                    />
                  ) : (
                    <ToggleOnIcon
                      sx={{ fontSize: 60, color: "green", cursor: "pointer" }}
                      onClick={() =>
                        setGroupForm((prev) => ({
                          ...prev,
                          alert: 0,
                        }))
                      }
                    />
                  )}
                  <div style={{ minHeight: "20px" }}>
                    {groupErrors.alert && (
                      <p className="text-danger small mb-0">
                        {groupErrors.alert}
                      </p>
                    )}
                  </div>
                </div>

                {/* Beep Sound */}
                <div className="d-flex flex-column align-items-center ms-5">
                  <p className="f3 mb-1 primary">Beep Sound</p>
                  {!groupForm.beep ? (
                    <ToggleOffIcon
                      sx={{ fontSize: 60, color: "gray", cursor: "pointer" }}
                      onClick={() =>
                        setGroupForm((prev) => ({
                          ...prev,
                          beep: 1,
                          alert: 1,
                        }))
                      }
                    />
                  ) : (
                    <ToggleOnIcon
                      sx={{ fontSize: 60, color: "green", cursor: "pointer" }}
                      onClick={() =>
                        setGroupForm((prev) => ({
                          ...prev,
                          beep: 0,
                        }))
                      }
                    />
                  )}
                  <div style={{ minHeight: "20px" }}>
                    {groupErrors.beep && (
                      <p className="text-danger small mb-0">
                        {groupErrors.beep}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="card shadow-sm border-0 rounded-4 mt-5">
          <div className="card-body text-center py-5">
            <div className="mb-3">
              <div className="bg-light rounded-circle d-inline-flex p-4">
                <i className="bi bi-person-video3 fs-1 text-muted"></i>
              </div>
            </div>
            <h5 className="text-muted mb-2">No group user found</h5>
            <p className="text-muted small mb-0">
              Please select site to add/view/edit group users
            </p>
          </div>
        </div>
      )}

      {/* Group Users List - Use CompanySitesAdd for edit mode, CompanyGroupView for view mode */}
      {selectedOption?.value &&
        groupUsers?.length > 0 &&
        (mode !== "view" ? (
          <CompanySitesAdd
            groupUsers={groupUsers}
            setGroupPopup={setGroupPopup}
            type={mode}
            deleteGroupUser={deleteGroupUser}
            handleGroupEdit={handleGroupEdit}
            groupUserStatus={groupUserStatus}
          />
        ) : (
          <CompanyGroupView groupUsers={groupUsers} />
        ))}

      {/* Show message when no group users */}
      {selectedOption?.value && groupUsers?.length === 0 && (
        <div className="text-center mt-5 p-5 border rounded bg-light">
          <p className="mb-0 f3 text-muted">
            No group users found for this site.
          </p>
        </div>
      )}

      {/* Delete Confirmation Popup */}
      {groupPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2 ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to delete the group user?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  deleteGroupUser(groupPopup);
                }}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setGroupPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyGroupUsers;
